import { removeNulls } from '..';

/**
 * Count all the nodes in a directed tree
 * @param {ProDirectedTreeNode} node
 * @returns {number} number of nodes in the tree
 */
export const countDirectedTreeNodes = (node: ProDirectedTreeNode): number => {
    let count = 0;

    // count this node
    count += 1;

    if (node.children === null) {
        return count;
    }

    // count its children
    const childCount = removeNulls(node.children).reduce(
        (acc: number, child: ProDirectedTreeNode): number =>
            acc + countDirectedTreeNodes(child),
        0,
    );

    return count + childCount;
};
